import { propsFactory } from "@ngneat/elf";

export const {
    withError,
    selectError,
    resetError,
    getError,
    setError,
    setErrorInitialValue
} = propsFactory("error", {
    initialValue: null as unknown as string,
});

export const {
    withLoading,
    selectLoading,
    resetLoading,
    getLoading,
    setLoading,
    setLoadingInitialValue
} = propsFactory("loading", {
    initialValue: false,
});

export const {
    withUpdatedAt,
    selectUpdatedAt,
    resetUpdatedAt,
    getUpdatedAt,
    setUpdatedAt,
    setUpdatedAtInitialValue
} = propsFactory("updatedAt", {
    initialValue: null as unknown as Date
})